import type {
  ApplyKeyPresetActivationRequest,
  ApplyKeyPresetActivationResponse,
  PreviewKeyPresetActivationRequest,
  PreviewKeyPresetActivationResponse,
  RollbackKeyPresetActivationResponse,
} from '@nadoutong/contracts';
import { useMutation } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import {
  applyKeyPresetActivation,
  previewKeyPresetActivation,
  rollbackKeyPresetActivation,
} from './keyPresetActivations.ts';

export function usePreviewKeyPresetActivation(): UseMutationResult<
  PreviewKeyPresetActivationResponse,
  Error,
  PreviewKeyPresetActivationRequest
> {
  const { fetchImpl } = useSession();
  return useMutation({ mutationFn: (body) => previewKeyPresetActivation(body, fetchImpl) });
}

export function useApplyKeyPresetActivation(): UseMutationResult<
  ApplyKeyPresetActivationResponse,
  Error,
  ApplyKeyPresetActivationRequest
> {
  const { fetchImpl } = useSession();
  return useMutation({ mutationFn: (body) => applyKeyPresetActivation(body, fetchImpl) });
}

export function useRollbackKeyPresetActivation(): UseMutationResult<
  RollbackKeyPresetActivationResponse,
  Error,
  string
> {
  const { fetchImpl } = useSession();
  return useMutation({ mutationFn: (operationId) => rollbackKeyPresetActivation(operationId, fetchImpl) });
}
